import { initCommonUiDropZoneTranslations } from './i18n';

export class CommonUiDropZoneModule {
  static async initialize(locale = 'en') {
    await initCommonUiDropZoneTranslations(locale);
  }
}
